module.exports = __webpack_public_path__ + "static/img/xxxx_xxhdpi.f967f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xxxx_xxhdpi.png
// module id = x5AQ
// module chunks = 1